import React, { useContext } from "react";

import { DataContext } from "../../../../../providers/ElectricityDataProvider";
import CalculatorMessage from "../../../../shared/CalculatorMessage";
import Campaign from "../../../../shared/Campaign";
import * as styles from "../Message/style.module.scss";

const Message = () => {
    const minimumSaved = 20;

    /**
     * FIXME: when the compain is over someone must manuelle change -100 to 50
     */
    //const minimumSaved = -100;

    const dataContext = useContext(DataContext);
    const { result: resultObj, loading, validResult } = dataContext.data;

    const result = resultObj ? Object.values(resultObj) : [];
    let resultGrundversorger = null;

    if (result.length > 1) {
        resultGrundversorger = result.find(
            (res) => res.isGrundversorgungsTarif === true
        );
    }

    return (
        !loading &&
        validResult &&
        Object.keys(result).length !== 0 &&
        result.constructor === Array &&
        resultGrundversorger &&
        result[0] &&
        result[0].ersparnisBrutto.replace(",", ".") >= minimumSaved && (
            <CalculatorMessage>
                <Campaign name="mitmachen2020">
                    <Campaign.Content>
                        <div className={styles.save}>
                            <span style={{ fontWeight: "bold" }}> 100 €. </span>
                            <span style={{ fontWeight: "normal" }}>
                                Jetzt noch schnell mitnehmen! Strom und Erdgas
                                bis zum{" "}
                            </span>
                            <span style={{ color: "red" }}>31.12.2020 </span>
                            <span>wechseln.</span>
                        </div>
                    </Campaign.Content>
                    <Campaign.Fallback>
                        <div className={styles.label}>Grundversorger:</div>
                        <div className={styles.name}>
                            {resultGrundversorger.versorgerName
                                ? resultGrundversorger.versorgerName
                                : ""}
                        </div>
                        <div className={styles.save}>
                            {" "}
                            Ersparnis bis zu: {result[0].ersparnisBrutto}
                            &nbsp;&euro;
                        </div>
                    </Campaign.Fallback>
                </Campaign>
            </CalculatorMessage>
        )
    );
};

export default Message;
